
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../functions/AuthContext";
import { puedeVerSOS } from "./acceso_sos";
import { iniciarVigilanciaSOS } from "./vigilancia_sos";
import { permisoNotificaciones, pedirPermisoNotificaciones } from "../../../functions/notificaciones_sos";
import "../../css/vigilante_sos.css";

const RUTA_SOS = "/sos";

const RUTAS_SIN_AVISO_VISUAL = [RUTA_SOS, "/sos_prueba"];

const VigilanteSOS = () => {
  const { usuario } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [estado, setEstado] = useState(null);
  const [permiso, setPermiso] = useState(permisoNotificaciones());

  const controlador = useRef(null);

  const irASOS = useRef(() => {});
  irASOS.current = () => navigate(RUTA_SOS);

  const habilitado = !!usuario && puedeVerSOS(usuario.email);

  useEffect(() => {
    if (!habilitado) return undefined;

    const control = iniciarVigilanciaSOS({
      alEstado: setEstado,
      alAbrirSOS: () => irASOS.current?.(),
    });

    controlador.current = control;

    return () => {
      controlador.current = null;
      control.detener();
    };
  }, [habilitado]);

  const enModuloSOS = RUTAS_SIN_AVISO_VISUAL.includes(pathname);
  useEffect(() => {
    controlador.current?.suprimirAvisoVisual(enModuloSOS);
  }, [enModuloSOS, estado?.listo]);

  if (!habilitado || !estado) return null;

  const { pendientes, nuevas, conectado, error } = estado;
  const total = pendientes.length;

  const activarNotificaciones = async () => {
    setPermiso(await pedirPermisoNotificaciones());
  };


  const avisos = [];

  if (!conectado) {
    avisos.push(
      <div key="sin-conexion" className="vsos-tira vsos-tira-aviso">
        <i className="bi bi-wifi-off" />
        <span>Sin conexión con el servidor. Las alertas SOS pueden estar llegando con retraso.</span>
        <button type="button" className="vsos-btn-plano" onClick={() => controlador.current?.revalidar()}>
          Reintentar
        </button>
      </div>
    );
  }

  if (error) {
    avisos.push(
      <div key="error" className="vsos-tira vsos-tira-aviso">
        <i className="bi bi-exclamation-circle" />
        <span>{error}</span>
      </div>
    );
  }

  const mostrarCampana = total > 0 && !enModuloSOS;

  const iconoPermiso =
    permiso === "denied"
      ? { clase: "bi-bell-slash", titulo: "Las notificaciones del navegador están bloqueadas para CoordiPH. El aviso sonoro y el parpadeo de la pestaña siguen funcionando.", onClick: undefined }
      : permiso === "default"
      ? { clase: "bi-bell", titulo: "Activa las notificaciones para enterarte de un SOS aunque estés en otra ventana.", onClick: activarNotificaciones }
      : null;

  if (!avisos.length && !mostrarCampana && !iconoPermiso) return null;

  return (
    <>
      {avisos.length > 0 && (
        <div className="vsos-capa" role="status" aria-live="assertive">
          {avisos}
        </div>
      )}

      {iconoPermiso && (
        <button
          type="button"
          className="vsos-campana vsos-campana-permiso"
          style={{ right: mostrarCampana ? 52 : 12 }}
          onClick={iconoPermiso.onClick}
          data-tooltip={iconoPermiso.titulo}
          aria-label={iconoPermiso.titulo}
        >
          <i className={`bi ${iconoPermiso.clase}`} aria-hidden="true" />
        </button>
      )}

      {mostrarCampana && (
        <button
          type="button"
          className={`vsos-campana ${nuevas.length > 0 ? "vsos-campana-nueva" : ""}`}
          onClick={() => navigate(RUTA_SOS)}
          data-tooltip={total === 1 ? "1 alerta SOS sin atender" : `${total} alertas SOS sin atender`}
          aria-label={total === 1 ? "1 alerta SOS sin atender" : `${total} alertas SOS sin atender`}
        >
          <i className="bi bi-bell-fill" aria-hidden="true" />
          <span className="vsos-campana-contador">{total > 99 ? "99+" : total}</span>
        </button>
      )}
    </>
  );
};

export default VigilanteSOS;
